import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PayrollDashboard from "@/components/payroll/PayrollDashboard";
import RunsPanel from "@/components/payroll/RunsPanel";
import PayrollSettings from "@/components/payroll/PayrollSettings";
import IncrementPlanning from "@/components/payroll/IncrementPlanning";

export default function PayrollPage() {
  const { user } = useAuth();
  if (!["admin", "hr_manager"].includes(user.role)) {
    return (
      <div className="border border-border bg-white p-10 text-center" data-testid="payroll-restricted">
        <Lock className="h-6 w-6 mx-auto text-muted-foreground mb-3" />
        <p className="text-[14px] text-slate-700">Payroll is restricted to Administrators and HR Managers.</p>
      </div>
    );
  }
  return (
    <div className="space-y-5 fade-in" data-testid="payroll-page">
      <Tabs defaultValue="dashboard">
        <TabsList className="rounded-none bg-white border border-border h-10 p-0">
          {[["dashboard", "Dashboard"], ["runs", "Payroll Runs"], ["increments", "Increment Planning"], ["settings", "Settings"]].map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`payroll-tab-${v}`}
              className="rounded-none h-full px-5 text-[12px] uppercase tracking-wider data-[state=active]:bg-[var(--brand-primary)] data-[state=active]:text-white">
              {l}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="dashboard" className="mt-4"><PayrollDashboard /></TabsContent>
        <TabsContent value="runs" className="mt-4"><RunsPanel /></TabsContent>
        <TabsContent value="increments" className="mt-4"><IncrementPlanning /></TabsContent>
        <TabsContent value="settings" className="mt-4"><PayrollSettings /></TabsContent>
      </Tabs>
    </div>
  );
}
